module.exports = "pegasus_template/assets/blocks/column-8-theme5.png";